import { v4 } from 'uuid';

// Error
const FETCH_FAILED_ERROR = '@@ux/drivers/fetch failed error';
let Method;
(function (Method) {
  Method["GET"] = "GET";
  Method["POST"] = "POST";
  Method["PUT"] = "PUT";
  Method["PATCH"] = "PATCH";
  Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
let Credentials;
(function (Credentials) {
  Credentials["INCLUDE"] = "include";
  Credentials["SAME_ORIGIN"] = "same-origin";
  Credentials["OMIT"] = "omit";
})(Credentials || (Credentials = {}));

const pipe = function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return a => fns.reduce((v, f) => f(v), a);
};
var pipe$1 = pipe;

const doFetch = () => _ref => {
  let {
    url,
    ...config
  } = _ref;
  return fetch(url, config)
  // fetch will only reject on a network error
  .catch(() => Promise.reject({
    error: FETCH_FAILED_ERROR
  })).then(resp => {
    // fetch actually resolves when the status is 400/500/etc.
    if (!resp.ok) {
      return resp.text().then(body => {
        const getPathname = () => {
          try {
            return new URL(resp.url).pathname;
          } catch {
            // msw returns resp.url as empty string
            return '';
          }
        };
        return Promise.reject({
          error: `${resp.status} (${resp.statusText}) - ${getPathname()}`,
          status: resp.status,
          statusText: resp.statusText,
          type: resp.type,
          url: resp.url,
          body
        });
      });
    }
    return Promise.resolve(resp);
  });
};
const createFetch = () => {
  return pipe$1(config => ({
    // default method to GET
    method: Method.GET,
    // credentials default to same origin in modern browsers
    // but older versions required you to explicitly set it
    // apparently the spec changed after every browser had implemented the fetch api!
    credentials: Credentials.SAME_ORIGIN,
    ...config
  }), config => {
    if (!config.data) {
      return config;
    }
    if (config.method === 'GET') {
      const {
        url,
        data,
        ...rest
      } = config;
      const query = new URLSearchParams();
      for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'string') {
          query.append(key, value);
        } else if (Array.isArray(value)) {
          for (const item of value) {
            query.append(key, item);
          }
        } else {
          query.append(key, JSON.stringify(value));
        }
      }
      return {
        ...rest,
        url: `${url}?${query}`
      };
    } else if (config.data instanceof FormData) {
      // Do not stringify form data as it will not set the correct headers
      const {
        data,
        ...rest
      } = config;
      return {
        ...rest,
        body: data
      };
    }
    const {
      data,
      ...rest
    } = config;
    return {
      ...rest,
      body: JSON.stringify(data)
    };
  }, doFetch());
};
const fetchFn = createFetch();
const http = fetchFn;
var createFetch$1 = createFetch;

const json = () => http => pipe$1(config => ({
  ...config,
  headers: {
    ...config.headers,
    'Content-Type': 'application/json'
  }
}), http, p => p.then(resp => {
  return resp.json().then(data => {
    return {
      response: resp,
      body: data
    };
  });
}, err => {
  if (err != null && typeof err.body === 'string') {
    try {
      return Promise.reject({
        response: err,
        body: JSON.parse(err.body)
      });
    } catch (e) {
      return Promise.reject({
        response: err,
        body: err.body
      });
    }
  }
  return Promise.reject(err);
}));
var json$1 = json;

const jsonRpc = () => http => _ref => {
  let {
    method,
    data,
    ...rest
  } = _ref;
  const id = v4();
  return http({
    ...rest,
    method: Method.POST,
    data: {
      jsonrpc: '2.0',
      id,
      method,
      params: data
    }
  }).then(response => {
    if (response.body.id !== id) {
      return Promise.reject({
        response: response.response,
        body: new Error('Invalid response')
      });
    }
    if (response.body.error) {
      return Promise.reject({
        response: response.response,
        body: response.body.error
      });
    }
    return Promise.resolve({
      response: response.response,
      body: response.body.result
    });
  });
};
var jsonRpc$1 = jsonRpc;

const middleware = function () {
  let defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http => _ref => {
    let {
      method,
      version,
      params
    } = _ref;
    const prefixedMethod = version != null ? `v${version}.${method}` : method;
    const config = {
      url: '/api/app',
      ...defaultConfig,
      method: prefixedMethod,
      data: params
    };
    return http(config);
  };
};
var middleware$1 = middleware;

const xray = () => http => pipe$1(config => ({
  ...config,
  headers: {
    ...config.headers,
    'X-Ray-Id': v4()
  }
}), http);
var xray$1 = xray;

const bodyOnly = () => http => pipe$1(http, promise => promise.then(resp => resp.body, resp => Promise.reject(resp.body)));
var bodyOnly$1 = bodyOnly;

export { Credentials, FETCH_FAILED_ERROR, Method, bodyOnly$1 as bodyOnly, createFetch$1 as createFetch, fetchFn as fetch, http, json$1 as json, jsonRpc$1 as jsonRpc, middleware$1 as middleware, pipe$1 as pipe, xray$1 as xray };
